import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff, Wand2 } from "lucide-react";
import { toast } from "sonner";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%";
const generate = () => Array.from(crypto.getRandomValues(new Uint32Array(14)), (n) => CHARS[n % CHARS.length]).join("");

export const PasswordField = ({ value, onChange, placeholder, testId }) => {
  const [show, setShow] = useState(false);
  const gen = () => {
    const p = generate();
    onChange(p); setShow(true);
    navigator.clipboard?.writeText(p).then(() => toast.success("Wachtwoord gegenereerd en gekopieerd")).catch(() => {});
  };
  return (
    <div className="relative w-full">
      <Input type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} className="pr-16" autoComplete="new-password" data-testid={testId} />
      <div className="absolute right-1 top-1/2 -translate-y-1/2 flex">
        <button type="button" onClick={() => setShow((s) => !s)} className="p-1.5 text-slate-400 hover:text-slate-700" title={show ? "Verbergen" : "Tonen"} data-testid={`${testId}-toggle`}>{show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}</button>
        <button type="button" onClick={gen} className="p-1.5 text-[#C9A227] hover:text-[#0F1E3D]" title="Sterk wachtwoord genereren" data-testid={`${testId}-generate`}><Wand2 className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
